import { useEffect, useState } from "react";
import { Select } from "antd";
import axios from "axios";
import { API_BASE_URL } from "../../api";


const TestValueSelect = ({ value, onChange, placeholder = "Select Test Value", ...props }) => {
  const [testValues, setTestValues] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchTestValues = async () => {
      try {
        setLoading(true);
        const response = await axios.get(`${API_BASE_URL}/textInfo/type/testValue`);
        setTestValues(response.data);
      } catch (_error) {
        console.error("Error fetching super groups:", _error);
        setTestValues([]);
      } finally {
        setLoading(false);
      }
    };
    fetchTestValues();
  }, []);

  return (
    <Select
      showSearch
      defaultValue={value}
      value={value}
      onChange={(val) => {
        if (onChange) onChange(val);
      }}
      placeholder={placeholder}
      loading={loading}
      filterOption={(input, option) =>
        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
      }
      {...props}
    >
      { testValues.map((testValue) => (
        <Select.Option key={testValue._id} value={testValue.value}>
          {testValue.value}
        </Select.Option>
      ))}
    </Select>
  );
};

export default TestValueSelect;
